module.exports = __webpack_public_path__ + "static/media/image02.91e5ebd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image02.jpg
// module id = 303
// module chunks = 0